/**
 * Regras de validação reutilizáveis para os campos dos formulários (Vuetify 2,
 * prop `:rules`). Devolvem `true` ou a mensagem exibida embaixo do campo.
 */

/**
 * Campo obrigatório. `false` e `0` CONTAM como preenchidos — "Não" é resposta
 * num select Sim/Não. Vazio é null, undefined, texto só com espaços ou lista
 * sem itens.
 */
export function required(v) {
  const vazio =
    v === null ||
    v === undefined ||
    (typeof v === "string" && v.trim() === "") ||
    (Array.isArray(v) && v.length === 0);
  return !vazio || "Campo obrigatório";
}

/** Número maior que zero (ex.: litros de água por dia). */
export function positive(v) {
  return (v !== "" && v != null && Number(v) > 0) || "Deve ser maior que zero";
}

/** Atalho para `canSave`: todos os valores passam em `required`. */
export function allFilled(...values) {
  return values.every((v) => required(v) === true);
}
